import React from 'react'
import { Grid } from '@mui/material'
import CountDown, { CountdownRenderProps, zeroPad } from 'react-countdown'
import RotatingBanner from 'components/Banner/RotatingBanner'

export interface CountdownTimerProps {
  countdownDate: string
  countdownLocation: 'pack' | 'banner' | 'hero' | 'maintenance'
}

export function PadMaintenance(props: any) {
  return (
    <div className="z-10 flex w-full items-center justify-center ">
      <Grid className="mx-8 flex text-center uppercase">
        <div className="flex w-[70px] items-center justify-center">
          <div className="flex w-[60px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="text-xl">{zeroPad(props.days)}</p>
            <p className="text-center text-[12px] font-bold leading-[18px] tracking-widest">
              DAYS
            </p>
          </div>
        </div>

        <div className="flex w-[70px] items-center justify-center">
          <div className="flex w-[60px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="text-xl">{zeroPad(props.hours)}</p>
            <p className="text-center text-[12px] font-bold leading-[18px] tracking-widest">
              HRS
            </p>
          </div>
        </div>

        <div className="flex w-[70px] items-center justify-center">
          <div className="flex w-[60px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="text-xl">{zeroPad(props.minutes)}</p>
            <p className="text-center text-[12px] font-bold leading-[18px] tracking-widest">
              MINS
            </p>
          </div>
        </div>
        <div className="flex w-[70px] items-center justify-center">
          <div className="flex w-[60px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="text-xl">{zeroPad(props.seconds)}</p>
            <p className="text-center text-[12px] font-bold leading-[18px] tracking-widest">
              SEC
            </p>
          </div>
        </div>
      </Grid>
    </div>
  )
}
export function PadBanner(props: any) {
  return (
    <div className="z-10 flex w-full items-center justify-center ">
      <Grid className="mx-8 flex text-center uppercase">
        <div className="flex w-[50px] items-center justify-center">
          <div className="flex w-[42px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="">{zeroPad(props.days)}</p>
            <p className="text-center text-[8px] font-bold leading-[10px] tracking-widest">
              DAYS
            </p>
          </div>
        </div>

        <div className="flex w-[50px] items-center justify-center">
          <div className="flex w-[42px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="">{zeroPad(props.hours)}</p>
            <p className="text-center text-[8px] font-bold leading-[10px] tracking-widest">
              HRS
            </p>
          </div>
        </div>

        <div className="flex w-[50px] items-center justify-center">
          <div className="flex w-[42px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="">{zeroPad(props.minutes)}</p>
            <p className="text-center text-[8px] font-bold leading-[10px] tracking-widest">
              MINS
            </p>
          </div>
        </div>
        <div className="flex w-[50px] items-center justify-center">
          <div className="flex w-[42px] flex-col items-center justify-center rounded-md bg-black1 px-[10px] py-[6px]">
            <p className="">{zeroPad(props.seconds)}</p>
            <p className="text-center text-[8px] font-bold leading-[10px] tracking-widest">
              SEC
            </p>
          </div>
        </div>
      </Grid>
    </div>
  )
}
export function PadPack(props: any) {
  return (
    <Grid className="flex rounded-[3px] bg-black2 px-[24px] py-[12px] text-center uppercase">
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.days)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.hours)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.minutes)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.seconds)}</p>
      </div>
    </Grid>
  )
}
export function Pad(props: any) {
  return (
    <Grid className="flex rounded-[3px] bg-black2 px-[24px] py-[16px] text-center uppercase">
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.days)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.hours)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.minutes)}</p>
      </div>
      <div className="">
        <p className="hero-countdown-text-pack">:</p>
      </div>
      <div className="flex w-[26px] flex-col justify-center">
        <p className="hero-countdown-text-pack">{zeroPad(props.seconds)}</p>
      </div>
    </Grid>
  )
}

const CountdownTimer = ({
  countdownDate,
  countdownLocation = 'hero'
}: CountdownTimerProps) => {
  const CountdownFinishedBanner = ({
    days,
    hours,
    minutes,
    seconds,
    completed
  }: CountdownRenderProps): React.ReactNode => {
    return (
      <div className="flex flex-col items-center justify-center px-3">
        {completed ? (
          <div>{countdownLocation === 'banner' && <RotatingBanner />}</div>
        ) : (
          <div>
            {countdownLocation === 'maintenance' && (
              <PadMaintenance
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
              />
            )}
            {countdownLocation === 'banner' && (
              <PadBanner
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
              />
            )}
            {countdownLocation === 'pack' && (
              <PadPack
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
              />
            )}
            {countdownLocation === 'hero' && (
              <Pad
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
              />
            )}
          </div>
        )}
      </div>
    )
  }

  return (
    <div>
      <CountDown date={countdownDate} renderer={CountdownFinishedBanner} />
    </div>
  )
}

export default CountdownTimer
